<template>
  <aside ref="modalRef" class="sdg-panel">
    <SDGPanelContent
      class="sdg-panel__content"
      :country="country"
      :sectors="sectors"
      :columnLabels="columnLabels"
      :text="text"
    />

    <button
      v-if="smallscreen"
      class="sdg-panel__close-btn"
      @click="$emit('onClose')"
    >
      <span>{{ $t("general.labels.close") }}</span>
    </button>
  </aside>
</template>

<script setup>
import { ref } from "vue";
import { onClickOutside } from "@vueuse/core";

import SDGPanelContent from "./SDGPanelContent.vue";

defineProps({
  country: String,
  sectors: {
    type: Array,
    default: () => [],
  },
  columnLabels: Object,
  text: String,
  smallscreen: Boolean,
});

const emit = defineEmits(["onClose"]);
const modalRef = ref(null);

onClickOutside(modalRef, (event) => emit("onClose", event));
</script>

<style lang="scss" scoped>
.sdg-panel {
  --close-tab: #{toRem(30)};

  background-image: var(--page-gradient);
  padding: calc(var(--modal-padding) * 0.5) var(--modal-padding);
  color: var(--white-100);
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 1;

  .desktop &,
  .large & {
    width: toRem(570);
    height: toRem(588);
  }

  .mobile &,
  .tablet & {
    width: calc(100vw - var(--close-tab));
    height: 100%;
    padding: 2rem var(--modal-padding);
  }

  &__content {
    --column-width: 8rem;
    --sector-width: #{toRem(270)};

    height: 100%;
  }

  &__close-btn {
    width: var(--close-tab);
    padding: 0.5rem;
    font-family: "EniTabBold";
    font-size: 1rem;
    line-height: toRem(19);
    text-transform: uppercase;
    background-color: #8a2f56;
    position: absolute;
    right: 100%;
    top: 50%;
    transform: translateY(-50%) rotate(180deg);

    span {
      writing-mode: vertical-rl;
    }
  }
}
</style>
